import { ReactComponent as InspectIcon } from '../../../assets/inspect.svg';
import { WidgetButton } from '../../../components';
import {
  DRAWER_TYPE,
  TEST_ID,
  TEST_OVERVIEW_SIDEPANEL_TAB,
  TEST_OVERVIEW_TAB_EXECUTION_INFO,
} from '../../../constants/urlParams';
import useNavigateWithEnvParam from '../../../hooks/useNavigateWithEnvParam';
import { isInSaaSMode } from '../../../utils/common';

type Props = {
  urlParam: string;
};

const OpenTestResultsButton = ({ urlParam }: Props) => {
  const navigate = useNavigateWithEnvParam();

  const handleClick = () => {
    if (isInSaaSMode()) {
      const searchParams = new URLSearchParams({
        [DRAWER_TYPE]: 'test',
        [TEST_ID]: urlParam,
        [TEST_OVERVIEW_SIDEPANEL_TAB]: TEST_OVERVIEW_TAB_EXECUTION_INFO,
      });
      navigate(`/report/test-results?${searchParams.toString()}`);
    } else {
      navigate(`/report/test-results/${urlParam}/`);
    }
  };

  return (
    <WidgetButton onClick={handleClick} startIcon={<InspectIcon />}>
      Last result
    </WidgetButton>
  );
};

export default OpenTestResultsButton;
